import { Injectable } from '@angular/core';
import { ModalOptions, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modals: NzModalRef[] = [];

  constructor(private modalService: NzModalService) {}

  create<T>(options: ModalOptions) {
    const modal = this.modalService.create<any, T>(options);
    this.modals.push(modal);
    return modal;
  }

  confirm(options: ModalOptions) {
    this.modals.push(this.modalService.confirm(options));
  }

  error(options: ModalOptions) {
    this.modals.push(this.modalService.error(options));
  }

  closeAll() {
    this.modals.forEach((d) => d.close());
    this.modals = [];
  }
}
